<template>
  <div class="header-layout">
    <div class="header-bar">
      <i class="el-icon-goods"/>
      U盟商城管理
      <div class="search">
        <el-select v-model="value" placeholder="功能选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-input v-model="input" placeholder="功能搜索"/>
        <el-button type="primary">搜索</el-button>
      </div>
    </div>
    <div class="userInfo">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{userName}}<i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a" >退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
<!-- </el-menu> -->
</template>

<script>
import {ERR_POST, ERR_BOSS} from 'api/config'
export default {
  data () {
    return {
      personnelShow: false,
      isBoss: false,
      userName: '',
      options: [{
        value: '选项1',
        label: '商品'
      }, {
        value: '选项2',
        label: '订单'
      }, {
        value: '选项3',
        label: '京东自营仓'
      }, {
        value: '选项4',
        label: '系统设置'
      }],
      value: '',
      input: ''
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    this.userName = getUserInfo.userName
    // console.log(this.userName);
  },
  methods: {
    handleSelect (key, keyPath) {
    },
    handleCommand (command) {
      // this.$message('click on item ' + command);
      this.signOut()
    },
    signOut () {
      window.localStorage.removeItem('getUserInfo')
      let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
      let _this = this
      if (!getUserInfo) {
        this.$message('退出成功')
        setTimeout(function () {
          _this.$router.push({
            path: '/'
          })
        }, 2000)
      }
    },
  }
}
</script>

<style lang="stylus">
@import '../../common/css/layui.css';
.header-layout {
  height: 70px;
  line-height: 70px;
  border-radius: 0px !important;
  background-color #ffffff
  box-shadow: #999 0 0 0.2rem;
  .header-bar {
    text-align: center;
    line-height: 70px;
    font-size: 20px;
    padding-left: 30px;
    color: #00C0FF;
    font-weight: bold;
    display: inline-block;
    .search{
      margin-left: 500px;
      display: inline-block;
      .el-select{
        width: 100px;
      }
      .el-input{
        width: 150px;
      }
    }
  }
  .signout {
    position: relative;
    top 10px;
  }
  .userInfo {
    position: absolute;
    top 0;
    right 0;
    width 100px;
    height 60px;
  }
  .userInfo .el-dropdown {
    color #00C0FF;
  }
  .userInfo .el-dropdown {
    height 60px;
    line-height 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue